<template>
  <div class="hello">
  <div class="hello-wrapper">
    <div class="col-left">
      <div class="blue">
        <h1>BIENVENUE CHEZ I.P.A.</h1>
<h2>leader du PLAN DE TRAVAIL
en corian®</h2>
<p>
La société I P A est le leader français spécialisé dans la transformation de DuPont™ Corian (marque leader de résine acrylique) et la réalisation de mobilier sur-mesure design pour de grands donneurs d'ordre, des professionnels et des particuliers.
</p>
<p>
Avec plus de 12 années d’expérience dans la transformation des "solid surfaces", IPA bénéficie de la certification « Transformateur Agréé Corian® » et vous propose des prestations de qualité en matière d'aménagement intérieur entre autres :
</p>
<p>
dans l'habitat (cuisines, salles de bains, habillages muraux, objets design…)
dans le tertiaire (sanitaires PMR, banques d’accueil…)
ainsi que dans l’univers de la santé (cabinets dentaires, hôpitaux…)
Notre force, c'est une équipe d’artisans menuisiers maîtrisant parfaitement la transformation de DuPont™ Corian® (matériau de revêtement homogène, massif, non poreux, réparable et thermo formable) ainsi qu’un atelier situé à 4 km de Paris et équipé des toutes dernières technologies nécessaires à la transformation en petites et grandes séries de cette résine de acrylique.
</p>
<p>
I P A assure un suivi de vos projets de A à Z avec un seul interlocuteur. Toutes nos créations sont à 100% des fabrications françaises !
</p>
<p>
Les professionnels de chez IPA se déplacent rapidement sur l’ensemble de l’Ile-de-France ainsi que sur la France entière pour étudier votre projet et pour vous apporter les réponses et les solutions techniques adéquates.
</p>
<p>
Après réception du projet ou visite sur site, nous vous soumettrons dans les plus brefs délais un devis gratuit, personnalisé et détaillé.
</p>
<p>
Quel que soit votre projet Corian®, n’hésitez pas à nous consulter… vous avez la garantie d’une excellente qualité puisque nous faisons partie du réseau Corian® et nous sommes enregistrés sous Numéro Quality Network 1106.
</p>
      </div>
    </div>
    <slider animation="normal" :auto="true" :indicators="false" :control-btn="true" style="flex-grow:1;height:auto;">
      <slider-item v-for="(i, index) in backgrounds" :key="index">
        <div :style="i" class="background-slide">
        </div>
      </slider-item>
    </slider>
  </div>
  <Foot />
</div>
</template>

<script>
import { Slider, SliderItem } from 'vue-easy-slider'

import Foot from '@/components/Foot.vue'
export default {
  data () {
    return {
      backgrounds: [
        { backgroundImage: 'url(/static/background.png)' },
        { backgroundImage: 'url(/static/background-2.jpg)' },
        { backgroundImage: 'url(/static/background-3.jpg)' }
      ]
    }
  },
  components: {
    Foot,
    Slider,
    SliderItem
  },
  mounted () {
    document.getElementById('btn_question').style.left = '570px'
    document.getElementById('btn_question').style.right = 'unset'
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>

.hello-wrapper {
  display: flex;
  /* background: url('/static/background.png');*/

}
.background-slide {
  background-size: cover !important;
  background-position: center center !important;
  width: 100%;
  height: 100%;
}
.col-left {
  width: 500px;
  display: flex;
  flex-direction: column;
  z-index: 200;
  box-sizing: border-box;

}
.blue {
  padding: 50px 30px;
  color: #FFF;
  text-align: left;
  background: #000;
}
h1, h2 {
  margin: 0;
  text-transform: uppercase;
}
h2 {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// Hello.vue?ea3e8888